module.exports = __webpack_public_path__ + "static/media/belle-win.c40574c1.png";